import { render, staticRenderFns } from "./WashServiceAddition.vue?vue&type=template&id=c38019a2&scoped=true&"
import script from "./WashServiceAddition.vue?vue&type=script&lang=js&"
export * from "./WashServiceAddition.vue?vue&type=script&lang=js&"
import style0 from "./WashServiceAddition.vue?vue&type=style&index=0&id=c38019a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38019a2",
  null
  
)

export default component.exports